<div class="p-4 hc-container mt-0">
    <h1 class="section-title-hygiene mb-2">{{ 'EVALUATION.STATISTICAL_EVALUATION' | translate }}</h1>
    <p class="col-12 pb-3 pl-0 static-card-desc">{{ 'CHECK.EVALUATION.INFO' | translate }}</p>
    <div class="row col p-0">
        <div class="col-sm-12 col-md-6 pr-0 d-flex">
            <div class=" static-card cursor w-100" (click)="emitData({key:'quickComments'})">
                <h1 class="section-title menuLink">{{ 'CHECK.EVALUATION.QUICK_COMMENTS' | translate }}</h1>
                <p>{{'CHECK.EVALUATION.QUICK_COMMENTS_INFO' | translate}}</p>
            </div>
        </div>
        <!-- <div class="col-sm-12 col-md-6 pr-0 d-flex">
            <div class=" static-card cursor" (click)="emitData({key:'complianceQuestions'})">
                <h1 class="section-title menuLink">{{ 'CHECK.EVALUATION.COMPLIANCE_QUESTION' | translate }}
                </h1>
                <p>{{ 'CHECK.EVALUATION.COMPLIANCE_QUESTION_INFO' | translate }}</p>
            </div>
        </div> -->
        <div class="col-sm-12 col-md-6 pr-0 d-flex">
            <div class=" static-card cursor w-100" (click)="emitData({key:'overallCompliance'})">
                <h1 class="section-title menuLink">{{ 'CHECK.EVALUATION.OVERALL_COMPLIANCE_SCORE' | translate }}</h1>
                <p>{{ 'CHECK.EVALUATION.OVERALL_COMPLIANCE_SCORE_INFO' | translate }}
                </p>
            </div>
        </div>
        <div class="col-sm-12 col-md-6 pr-0 d-flex">
            <div class=" static-card cursor w-100" (click)="emitData({key:'individualData'})">
                <h1 class="section-title menuLink">{{ 'CHECK.EVALUATION.INDIVIDUAL_AUDIT_DATA_OVERVIEW' | translate }}</h1>
                <p>{{ 'CHECK.EVALUATION.INDIVIDUAL_AUDIT_DATA_OVERVIEW_INFO' | translate }}
                </p>
            </div>
        </div>
    </div>
</div>